
      let Page = require('/home/toannc/ekmap-platform-map-javascript/docs/pages/javascript-api/service.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Truy vấn thông tin",
    "id": "service",
    "description": "Truy vấn thông tin.",
    "contentType": "API",
    "order": 3,
    "layout": "page",
    "hideFeedback": false,
    "products": [
      "Documentation"
    ],
    "prependJs": [
      "import OverviewHeader from '@mapbox/dr-ui/overview-header';",
      "import Copyable from '../../components/copyable';",
      "import Note from '@mapbox/dr-ui/note';",
      "import Related from '../../components/api/related';",
      "import Example from '../../components/example';"
    ]
  }
}
      };
    